"use strict";

module.exports = values;
function values(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/values/index.js
// module id = 953
// module chunks = 0